module.exports = __webpack_public_path__ + "static/media/slider-thumb-engine.e4cecce5.png";